import { GCADANavigation } from '@GCADA/types';

export const navigation: GCADANavigation[] = [
  {
    id: 'membermenu',
    title: 'Member',
    translate: 'NAV.MEMBER',
    type: 'group',
    icon: 'apps',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        translate: 'NAV.DASHBOARD',
        type: 'item',
        icon: 'dashboard',
        url: '/apps/dashboard'
      },
      {
        id: 'events',
        title: 'Events',
        translate: 'NAV.EVENTS',
        type: 'item',
        icon: 'event_note',
        url: '/apps/admin/events'
      },
      {
        id: 'departments',
        title: 'Departments',
        translate: 'NAV.DEPARTMENTS',
        type: 'collapsable',
        icon: 'account_balance',
        children: []
      },
      {
        id: 'legalregulatory',
        title: 'Legal & Regulatory',
        translate: 'NAV.LEGALREGULATORY',
        type: 'collapsable',
        icon: 'receipt' ,
        children: []   
      },
      {
        id: 'registrationreports',
        title: 'Registration Reports',
        translate: 'NAV.REGISTRATIONREPORT',
        type: 'item',
        icon: 'account_circle',
        openInNewTab: true,
        url: '/pages/content/registration-reports/4/39'
      }
    ]
  },
  {
    id: 'admin',
    title: 'Admin',
    type: 'group',
    icon: 'pages',
    children: [
      {
        id: 'systemadministration',
        title: 'System Administration',
        type: 'collapsable',
        icon: 'supervised_user_circle',
        groupShow: '1,6',
        children: [
          {
            id: 'emailblast',
            title: 'Email Blast',
            type: 'item',
            url: '/apps/admin/email-blast'
          },
          {
            id: 'pages',
            title: 'Pages',
            type: 'item',
            url: '/apps/admin/pages'
          },
          {
            id: 'users',
            title: 'Users',
            type: 'item',
            url: '/apps/admin/users'
          },
          // {
          //     id: 'groups',
          //     title: 'Groups',
          //     type: 'item',
          //     url: '/pages/pages'
          // },
          // {
          //     id: 'types',
          //     title: 'Types',
          //     type: 'item',
          //     url: '/pages/pages'
          // },
          {
            id: 'sdm',
            title: 'SDM',
            type: 'item',
            url: '/apps/admin/sdm-group'
          },
          {
            id: 'companies',
            title: 'Companies',
            type: 'item',
            url: '/apps/admin/companies'
          },
          {
            id: 'tests',
            title: 'Tests',
            type: 'item',
            url: '/apps/admin/tests'
          },
          {
            id: 'resources',
            title: 'Resources',
            type: 'item',
            url: '/apps/admin/resources'
          },
          {
            id: 'compliance',
            title: 'Compliance',
            type: 'item',
            url: '/apps/admin/compliance'
          }
          // {
          //     id: 'dealergrps',
          //     title: 'Dealer GRPS',
          //     type: 'item',
          //     url: '/pages/pages'
          // }
        ]
      },
      // {
      //   id: 'calltrakingsystem',
      //   title: 'Call Tracking System',
      //   type: 'item',
      //   icon: 'call_missed_outgoing',
      //   groupShow: '1,4',
      //   url: '/apps/admin/call-tracking-system'
      // },
      // {
      //   id: 'calltrakingreport',
      //   title: 'Call Tracking Reports',
      //   type: 'item',
      //   icon: 'call_to_action',
      //   groupShow: '1,4',
      //   url: '/apps/admin/call-tracking-reports'
      // },
      // {
      //   id: 'admincompany',
      //   title: 'Admin Company Compliance',
      //   type: 'item',
      //   icon: 'view_compact',
      //   groupShow: '1',
      //   url: '/apps/admin/company-compliance'
      // },
      // {
      //   id: 'admingroup',
      //   title: 'Admin Group Compliance',
      //   type: 'item',
      //   icon: 'group',
      //   groupShow: '1',
      //   url: '/apps/admin/group-compliance'
      // },
      {
        id: 'safemMgmt',
        title: 'S.A.F.E. Management',
        type: 'collapsable',
        icon: 'assessment',
        groupShow: '9,10',
        children: [
          {
            id: 'safeauditformmgmt',
            title: 'S.A.F.E. Audit Form Mgmt',
            type: 'item',
            groupShow: '9',
            url: '/apps/admin/safe-audit-form-mgmnt'
          },
          {
            id: 'safeaudits',
            title: 'S.A.F.E. Audits',
            type: 'item',
            groupShow: '9',
            url: '/apps/admin/safe-audits'
          },
          {
            id: 'safeauditarchives',
            title: 'S.A.F.E. Audit Archives',
            type: 'item',
            groupShow: '9',
            url: '/apps/admin/safe-audits-archives'
          },
          {
            id: 'safeaudit',
            title: 'Create SAFE Audit',
            type: 'item',
            groupShow: '10',
            url: '/apps/admin/safe-audit'
          }
        ]
      },
      {
        id: 'usermanagement',
        title: 'User Management',
        type: 'item',
        icon: 'group',
        groupShow: '3',
        url: '/apps/admin/user-management'
      },
      // {
      //   id: 'compliancemanagement',
      //   title: 'Compliance Management',
      //   type: 'item',
      //   icon: 'note_add',
      //   groupShow: '3',
      //   url: '/pages/pages'
      // },
      {
        id: 'compliancereport',
        title: 'Compliance Reports',
        type: 'item',
        icon: 'report',
        groupShow: '3',
        url: '/apps/admin/report/compliance'
      },
      // {
      //     id: 'groupusermanagement',
      //     title: 'Group User Management',
      //     type: 'item',
      //     icon: 'nature_people',
      //     groupShow: '8',
      //     url: '/pages/pages'
      // },
      // {
      //     id: 'groupcompliancemgmt',
      //     title: 'Group Compliance Mgmt',
      //     type: 'item',
      //     icon: 'account_box',
      //     groupShow: '8',
      //     url: '/pages/pages'
      // },
      {
        id: 'employeecompliance',
        title: 'Employee Compliance',
        type: 'item',
        icon: 'view_comfy',
        groupShow: '2',
        url: '/apps/admin/employee-compliance'
      },
      // {
      //   id: 'safe',
      //   title: 'S.A.F.E.',
      //   type: 'item',
      //   sdGroupShow: '141,273',
      //   icon: 'data_usage',
      //   url: '/apps/admin/safe'
      // },
      {
        id: 'registrationreportupload',
        title: 'Registration Report Upload',
        type: 'item',
        icon: 'report',
        groupShow: '3',
        url: '/apps/admin/report/registration-report-upload'
      },

    ]
  }
];
